import { Clickable, Icon, Row } from 'components';
import { Api } from 'lib';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { ItemGroup } from './components';

const Underlay = styled.div`
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 11;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HighlightsSlider = ({ data, fetchMore, startingIndex, visible, closeModal, userId }) => {
  const [state, setState] = useState(null);
  const [current, setCurrent] = useState(null);
  const [index, setIndex] = useState(null);

  useEffect(() => {
    if (!visible) {
      setIndex(null);
      setCurrent(null);

      return;
    }

    if (userId) return fetchStories();

    setIndex(startingIndex);
    setCurrent(data[startingIndex]);
    setState(data);
  }, [visible]);

  async function fetchStories() {
    const res = await Api.post('/stories/get', { userId });
    if (!res) return;

    setIndex(0);
    setCurrent(res);
    setState([res]);
  }

  function handleNext() {
    if (index + 1 === state?.length) return closeModal();

    setIndex(index + 1);
    setCurrent(state[index + 1]);
  }

  function handlePrev() {
    if (!index) return closeModal();

    setIndex(index - 1);
    setCurrent(state[index - 1]);
  }

  if (!visible || (!data?.length && !userId)) return null;

  return (
    <Underlay>
      <Clickable onClick={closeModal}>
        <Row
          pos="fixed"
          right="24px"
          top="24px"
          pad="10px"
          hasRadius="32px"
          hasBorder="2px solid #fff"
        >
          <Icon type="close" col="#fff" dimensions={14} />
        </Row>
      </Clickable>

      <ItemGroup data={current} handleNext={handleNext} handlePrev={handlePrev} />
    </Underlay>
  );
};

export default HighlightsSlider;
